import BusinessProfileModel from "models/business-profiles/BusinessProfile";
import { SubscriptionModel } from "models/payments/subscriptions";
import { OneTimePurchaseModel } from "models/payments/one-time-purchase";
import { PricingTranslations } from "i18n/containers/Pricing/typing";

export const mapBusinessProfileFromElearningSubscription = (
	businessProfile: BusinessProfileModel,
	subscriptions: SubscriptionModel[],
	pricingTranslations: PricingTranslations,
) => {
	const subscriptionsForThisBusinessProfile = subscriptions.filter(
		(subscription) => subscription.businessProfileId == businessProfile.info.id,
	);
	const isAlreadySubscribed = subscriptionsForThisBusinessProfile.find(
		(subscription) => subscription.status === "active",
	);

	return {
		value: businessProfile.info.id,
		key: businessProfile.info.id,
		text: businessProfile.info.fullName,
		image: businessProfile.info.avatar,
		label: isAlreadySubscribed && {
			content: pricingTranslations.alreadySubscribed,
			size: "medium",
			color: "orange",
			attached: "top right",
		},
		disabled: Boolean(isAlreadySubscribed),
	};
};

export const mapBusinessProfileFromTalentSubscription = (
	businessProfile: BusinessProfileModel,
	subscriptions: SubscriptionModel[],
	pricingTranslations: PricingTranslations,
) => {
	const subscriptionsForThisBusinessProfile = subscriptions.filter(
		(subscription) => subscription.businessProfileId == businessProfile.info.id,
	);
	const purchasedTalents = subscriptionsForThisBusinessProfile.reduce((prevValue, currentValue) => {
		return prevValue + currentValue.quantityIfActiveStatus;
	}, 0);
	let labelData;

	if (purchasedTalents > 0) {
		labelData = {
			content: `${purchasedTalents} ${pricingTranslations.acquiredTalents}`,
			size: "medium",
			color: "orange",
			attached: "top right",
		};
	}

	return {
		value: businessProfile.info.id,
		key: businessProfile.info.id,
		text: businessProfile.info.fullName,
		image: businessProfile.info.avatar,
		label: labelData,
	};
};

export const mapBusinessProfileFromChallengeOneTimePurchase = (
	businessProfile: BusinessProfileModel,
	oneTimePurchases: OneTimePurchaseModel[],
	pricingTranslations: PricingTranslations,
) => {
	const oneTimePurchasesForThisBusinessProfile = oneTimePurchases.filter(
		(subscription) => subscription.businessProfileId == businessProfile.info.id,
	);
	const purchasedChallenges = oneTimePurchasesForThisBusinessProfile.reduce((prevValue, currentValue) => {
		return prevValue + currentValue.quantityIfActiveStatus;
	}, 0);
	let labelData;

	if (purchasedChallenges > 0) {
		labelData = {
			content: `${purchasedChallenges} ${pricingTranslations.acquiredChallenges}`,
			size: "medium",
			color: "orange",
			attached: "top right",
		};
	}

	return {
		value: businessProfile.info.id,
		key: businessProfile.info.id,
		text: businessProfile.info.fullName,
		image: businessProfile.info.avatar,
		label: labelData,
	};
};
